(() => {
  const text = JSON.parse(document.getElementById('pxs-checkout-text')?.textContent || '{}');
  const resumeKey = 'pxs-cart-open-after-update';
  let opening = false;
  let opener;
  let wasOpen = false;
  let wasDownsellOpen = false;
  let scheduled = false;
  const styledForms = new WeakSet();
  const activeDownsell = () => {
    const offer = document.getElementById('es-downsell');
    return offer?.getClientRects().length ? offer : null;
  };
  const isOpen = () => Boolean(document.querySelector('#es-form')?.getClientRects().length);
  const statusFor = form => form.querySelector('[data-pxs-cart-message], [data-pxs-form-message]') || form.closest('[data-pxs-card]')?.querySelector('[data-pxs-form-message]');
  const message = (form, value, retry = false) => {
    const status = statusFor(form);
    if (!status) return;
    status.hidden = !value;
    status.replaceChildren(document.createTextNode(value));
    if (retry) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'pxs-checkout-retry';
      button.textContent = text.retry;
      button.addEventListener('click', () => location.reload());
      status.append(' ', button);
    }
  };
  const waitFor = (check, timeout = 10000) => new Promise(resolve => {
    const start = performance.now();
    const checkAgain = () => {
      const value = check();
      if (value || performance.now() - start >= timeout) resolve(value || null);
      else setTimeout(checkAgain, 100);
    };
    checkAgain();
  });
  const findButton = form => form.matches('[data-pxs-cart-form]')
    ? form.querySelector('.pxs-cart-summary .es-popup-button-cart') || form.querySelector('.es-popup-button-cart')
    : form.querySelector('.es-popup-button');
  const openOrder = async button => {
    const form = button.closest('form');
    if (!form || opening || isOpen() || button.disabled || !form.reportValidity()) return;
    const variant = form.querySelector('[name="id"]');
    if (variant && (!variant.value || variant.selectedOptions?.[0]?.disabled)) return;
    const stockButton = form.querySelector('[name="add"]');
    if (stockButton?.disabled) return;
    opener = button;
    opening = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      if (form.dataset.pxsCartDirty === 'true') {
        try { sessionStorage.setItem(resumeKey, String(Date.now())); } catch {}
        message(form, text.updating);
        form.requestSubmit(form.querySelector('[name="update"]'));
        return;
      }
      message(form, text.loading);
      const native = await waitFor(() => findButton(form));
      if (!native) throw new Error(text.unavailable);
      native.click();
      if (!await waitFor(isOpen)) throw new Error(text.unavailable);
      message(form, '');
      schedule();
    } catch (error) {
      message(form, error.message || text.unavailable, true);
    } finally {
      opening = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };
  const updateForm = () => {
    scheduled = false;
    const form = document.getElementById('es-form');
    if (!form) return;
    const container = document.getElementById('es-form-container');
    if (container && !container.hasAttribute('role')) {
      container.setAttribute('role', 'dialog');
      container.setAttribute('aria-modal', 'true');
      container.setAttribute('aria-label', text.title);
    }
    const close = form.querySelector('.close-icon');
    if (close && !close.hasAttribute('tabindex')) {
      close.tabIndex = 0;
      close.setAttribute('role', 'button');
      close.setAttribute('aria-label', text.close);
    }
    const coupon = form.querySelector('.es-discount-group');
    if (coupon && !form.querySelector('[data-pxs-coupon-toggle]')) {
      coupon.id = 'pxs-coupon-fields';
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'pxs-coupon-toggle';
      toggle.setAttribute('data-pxs-coupon-toggle', '');
      toggle.setAttribute('aria-controls', coupon.id);
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = text.coupon;
      coupon.before(toggle);
      coupon.classList.add('pxs-coupon-collapsed');
    }
    if (!form.querySelector('[data-pxs-cod-note]')) {
      const note = document.createElement('p');
      note.dataset.pxsCodNote = '';
      note.className = 'pxs-cod-note';
      note.textContent = text.cod;
      form.append(note);
    }
    if (!styledForms.has(form)) {
      styledForms.add(form);
      new MutationObserver(schedule).observe(container, {subtree:true, childList:true, attributes:true, attributeFilter:['style','class']});
    }
    const downsell = document.getElementById('es-downsell');
    if (downsell && !styledForms.has(downsell)) {
      styledForms.add(downsell);
      new MutationObserver(schedule).observe(downsell, {attributes:true, attributeFilter:['style','class']});
    }
    const offer = activeDownsell();
    const open = isOpen();
    if (offer && !wasDownsellOpen) offer.querySelector('.es-downsell-buttons button')?.focus({preventScroll:true});
    if (!offer && open && (!wasOpen || wasDownsellOpen)) close?.focus({preventScroll:true});
    wasDownsellOpen = Boolean(offer);
    if (!open && wasOpen && opener?.isConnected) opener.focus({preventScroll:true});
    wasOpen = open;
    document.body.classList.toggle('pxs-checkout-open', open);
  };
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(updateForm); }
  }
  document.addEventListener('click', event => {
    const order = event.target.closest('[data-pxs-order]');
    if (order) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openOrder(order);
      return;
    }
    const toggle = event.target.closest('[data-pxs-coupon-toggle]');
    if (toggle) {
      const expanded = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(expanded));
      document.getElementById('pxs-coupon-fields')?.classList.toggle('pxs-coupon-collapsed', !expanded);
      if (expanded) document.getElementById('es-discount')?.focus();
    }
  }, true);
  document.addEventListener('input', event => {
    if (event.target.matches('[data-pxs-cart-form] input[name="updates[]"]')) event.target.form.dataset.pxsCartDirty = 'true';
  });
  document.addEventListener('keydown', event => {
    const offer = activeDownsell();
    if (!isOpen() && !offer) return;
    const form = offer || document.getElementById('es-form');
    const close = offer ? offer.querySelector('.es-downsell-buttons button:last-child') : form.querySelector('.close-icon');
    if (event.key === 'Escape' || (event.target === close && ['Enter',' '].includes(event.key))) {
      event.preventDefault();
      close?.click();
      schedule();
    }
    if (event.key === 'Tab') {
      const focusable = Array.from(form.querySelectorAll('button,input,select,a[href],[tabindex="0"]')).filter(el => !el.disabled && el.getClientRects().length);
      const first = focusable[0], last = focusable.at(-1);
      if (event.shiftKey && (document.activeElement === first || !form.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  });
  new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true});
  try {
    const resume = Number(sessionStorage.getItem(resumeKey));
    sessionStorage.removeItem(resumeKey);
    if (resume && Date.now() - resume < 30000) {
      const button = document.querySelector('[data-pxs-cart-form] [data-pxs-order]');
      if (button) openOrder(button);
    }
  } catch {}
  schedule();
})();

